export const COURSE_REPORT_LIST_REQUEST = "COURSE_REPORT_LIST_REQUEST";
export const COURSE_REPORT_LIST_SUCCESS = "COURSE_REPORT_LIST_SUCCESS";
export const COURSE_REPORT_LIST_FAILURE = "COURSE_REPORT_LIST_FAILURE";

export const PRINT_COURSE_REPORT_REQUEST = "PRINT_COURSE_REPORT_REQUEST";
export const PRINT_COURSE_REPORT_SUCCESS = "PRINT_COURSE_REPORT_SUCCESS";
export const PRINT_COURSE_REPORT_FAILURE = "PRINT_COURSE_REPORT_FAILURE";
